import { render, staticRenderFns } from "./ConversionCard.vue?vue&type=template&id=23e9cb42&scoped=true"
import script from "./ConversionCard.vue?vue&type=script&lang=js"
export * from "./ConversionCard.vue?vue&type=script&lang=js"
import style0 from "./ConversionCard.vue?vue&type=style&index=0&id=23e9cb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9cb42",
  null
  
)

export default component.exports